import axios from 'axios';

import {
    API_URL_GET_ADMIN_DASHBAORD,
    API_URL_GET_ADMIN_DASHBAORD_BASE,
    API_URL_GET_ADMIN_DASHBAORD_RISK_MATRIX,
    API_URL_GET_ADMIN_DASHBAORD_HEATMAP,
    API_URL_GET_ADMIN_DASHBAORD_RISK_CATEGORIES,
    API_URL_GET_ADMIN_DASHBAORD_SUPPLIERS_SCORE,
    API_URL_GET_ADMIN_DASHBAORD_RISK_RATE
} from '../../constants/index';

export default class DashboardService {
	static instance;

	static getInstance() {
		if (!DashboardService.instance) {
			DashboardService.instance = new DashboardService();
		}

		return DashboardService.instance;
	}

    async fetchBaseData(params = {}) {
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD_BASE, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchRiskMatrixData(params = {}) {
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD_RISK_MATRIX, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchHeatmapData(params = {}) {
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD_HEATMAP, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchRiskCategoriesData(params = {}) {
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD_RISK_CATEGORIES, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchSuppliersScoreData(params = {}) {
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD_SUPPLIERS_SCORE, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetchRiskRatesData(params = {}) {
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD_RISK_RATE, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }

    async fetch(params = {}){
        const response = await axios.get(API_URL_GET_ADMIN_DASHBAORD, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data?.data || null
    }
}
